import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { Table, Button, Tooltip, Modal, Tag } from 'antd';
import { UserAccessContext } from 'context/userAccess';
import { GLOBAL_TABLE_SIZE } from 'global_config/constant-global';
import { FlagOutlined } from '@ant-design/icons';

import './index.css';

function ExpandedTable(props) {
	const { expandedData, onClickTableRow, onClickPrint } = props;
	const { contents, ...restProps } = expandedData;
	const { userAccess } = useContext(UserAccessContext);
	const [isPrintLoading, setIsPrintLoading] = useState([]);
	const [remarks, setRemarks] = useState('');
	const [modalReject, setModalReject] = useState(false);

	// console.log(contents)

	async function onPrint(record, index, selectedSectionName) {
		await setIsPrintLoading(prevState => getPrintLoadingState(prevState, index, true));

		await onClickPrint(
			record.sampleSpecimenID,
			expandedData.requestID,
			record.specimenStatus,
			selectedSectionName,
		);

		setIsPrintLoading(prevState => getPrintLoadingState(prevState, index, false));
	}

	function getPrintLoadingState(printLoadingArray, index, isLoading) {
		const printLoadingClone = [...printLoadingArray];
		printLoadingClone[index] = isLoading;

		return printLoadingClone;
	}

	function getStatusColor(status) {
		if (status === 0) {
			return '#C65911';
		} else if (status === 1) {
			return '#833C0C';
		} else if (status ===2) {
			return '#BF8F00';
		} else if (status === 3) {
			return '#00B050';
		} else if (status === 4) {
			return '#FC1C04';
		} else if (status === 5) {
			return '#305496';
		} else if (status === 6) {
			return '#002060';
		} else if (status === 7) {
			return '#CC66FF';
		} else if (status === 8) {
			return '#00B050';
		} else if (status === 9) {
			return '#FC1C04';
		} else {
			return '#8A73F9'; // default color if status doesn't match any range
		}
	}

	const columns = [
		{
			title: 'SECTION',
			dataIndex: 'sectionName',
			width: 50,
		},
		{
			title: 'SAMPLE ID NO.',
			dataIndex: 'sampleSpecimenID',
			width: 30,
		},
		{
			title: 'SPECIMEN',
			dataIndex: 'specimenName',
			width: 50,
		},
		{
			title: 'EXAM REQUESTED',
			dataIndex: 'examRequestNames',
			width: 50,
		},
		// {
		// 	title: '',
		// 	dataIndex: 'specimenStatusID',
		// 	width: 20,
		// 	render: (value, row) => {
		// 		let buttonColor;

		// 		// Determine color based on statusID
		// 		if (row.specimenStatusID >= 0 && row.specimenStatusID <= 3) {
		// 			buttonColor = 'green';
		// 		} else if (row.specimenStatusID >= 5 && row.specimenStatusID <= 8) {
		// 			buttonColor = 'yellow';
		// 		} else if (row.specimenStatusID >= 9 && row.specimenStatusID <= 10) {
		// 			buttonColor = 'red';
		// 		} else if (row.specimenStatusID === 4) {
		// 			buttonColor = 'orange';
		// 		} else {
		// 			// Default color if statusID doesn't match any range
		// 			buttonColor = '8A73F9';
		// 		}

		// 		return (
		// 			<Tooltip title={row.specimenStatus}>
		// 				<Button
		// 					icon={<FlagOutlined />}
		// 					style={{
		// 						marginLeft: 10,
		// 						borderColor: 'transparent',
		// 						color: buttonColor,
		// 					}}
		// 					onClick={() => handleOnClickStatus(row.specimenRemarks)}
		// 				/>
		// 			</Tooltip>
		// 		);
		// 	},
		// },
		{
			title: 'STATUS',
			dataIndex: 'specimenStatus',
			width: 10,
			render: (text, record) => (
				<Tag
					style={{
						cursor: 'pointer', // Add cursor pointer for better UX
					}}
					onClick={() => handleOnClickStatus(record.specimenRemarks)}
					color={getStatusColor(record.specimenStatusID)}
				>
					{text.toUpperCase()}
				</Tag>
			),
		},
		{
			title: '',
			width: 10,
			render: (text, record, index) => {
				if (!userAccess.result.print) return null;
				const sectionName = record.sectionName;
				return (
					<UserAccessContext.Consumer>
						{value =>
							value.userAccess.result.print && (
								<Button
									loading={isPrintLoading[index]}
									onClick={() => onPrint(record, index, sectionName)}
									// onClick={() => console.log(record, 'onprint')}
									disabled={
										!(
											record.specimenStatusID === 2 ||
											record.specimenStatusID === 3 ||
											record.specimenStatusID === 4 ||
											record.specimenStatusID === 8
										)
									}
								>
									PREVIEW
								</Button>
							)
						}
					</UserAccessContext.Consumer>
				);
			},
		},
	];

	const handleOnClickStatus = remarks => {
		if (remarks != null) {
			if (remarks.length > 0) {
				setRemarks(remarks);
				setModalReject(true);
			}
		}
	};

	const handleOkCancelReject = () => {
		setModalReject(false);
	};

	return (
		<>
			<Modal
				title="Reject Reason"
				visible={modalReject}
				onOk={handleOkCancelReject}
				onCancel={handleOkCancelReject}
			>
				<p>{remarks}</p>
			</Modal>
			<Table
				className="lab-result-expanded-table"
				columns={columns}
				dataSource={contents}
				pagination={false}
				size={GLOBAL_TABLE_SIZE}
				rowKey={record => `${record.sampleSpecimenID}-${record.specimenID}`}
				onRow={record => {
					return {
						onDoubleClick: () => {
							if (record.specimenStatusID !== 9) {
								onClickTableRow({
									examDetails: record,
									patientInfo: { ...restProps },
								});
							}
						},
					};
				}}
			/>
		</>
	);
}

ExpandedTable.propTypes = {
	expandedData: PropTypes.shape({
		contents: PropTypes.array,
	}).isRequired,
	onClickTableRow: PropTypes.func.isRequired,
	onClickPrint: PropTypes.func.isRequired,
};

export default ExpandedTable;
